import React, { useEffect } from 'react';
import packageJson from '../../../package.json';
import { useSelector } from 'react-redux';
import { RootState } from "../../redux/rootReducer";
import { toast } from 'react-toastify';


function Footer() {
  const me = useSelector((state: RootState) => state.auth.me);
  
  useEffect(() => {
    if (me?.version) {
      if (me.version !== packageJson.version) {
        toast.warning(
          'The dashboard version does not match the server version. ' +
          'Please contact your administrator to update the dashboard to matched version.'
        );
      }
    }
  }, [me]);
  
  return (
    <div className="relative w-full">
      <div className="absolute right-0">
        <p className="text-right text-base-500 text-[12px]">
          V{packageJson.version}X{me?.version}
        </p>
      </div>

    </div>
  );
}

export default Footer;
